import { Component, OnInit, Input, Output } from '@angular/core';
import { CampaignResource } from '../../../../core/resources/campaign-resources';
import { Subject, BehaviorSubject } from 'rxjs';
import { FormGroup, AbstractControl, FormArray, FormBuilder, Validators } from '@angular/forms';
import { ApiService, Resource } from '../../../../core/services/api.service';
import { SweetAlertService } from '../../../../core/services/sweet-alert.service';
import { CompanyResource } from '../../../../core/resources/company-resources';
import { ResourceCollection } from '../../../../core/api/resources/resource-collection';

@Component({
  selector: 'app-export-interactions',
  templateUrl: './export-interactions.component.html',
  styleUrls: ['./export-interactions.component.scss']
})
export class ExportInteractionsComponent implements OnInit {

  @Input() public campaign: CampaignResource = null;
  @Input() public advancedFilters = false;
  @Output() public valueChanged = new Subject<FormGroup>();

  public frm: FormGroup;
  public cfg: FormGroup;
  public types: string[] = [];
  public campaigns: CampaignResource[] = [];
  public companies: CompanyResource[] = [];
  constructor(private readonly fb: FormBuilder, private readonly api: ApiService, private readonly sw: SweetAlertService) {

    this.cfg = fb.group({
      type: [null, Validators.nullValidator],
      campaign: [null, Validators.nullValidator],
      company: [null, Validators.nullValidator],
      from: [null, Validators.nullValidator],
      until: [null, Validators.nullValidator]
    });

    this.frm = fb.group({
      type: ['Interaction', Validators.required],
      name: [null, Validators.required],
      configuration: this.cfg
    });
  }

  public ngOnInit() {
    this.refreshRef();
    if (this.campaign) {
      this.cfg.get('campaign').setValue(this.campaign.id);
    }
    this.notifyChanged();
  }

  public refreshRef(): void {
    this.api.resource(Resource.REQUEST_LOG_TYPES).list().subscribe((data: string[]) => { this.types = data; });
    this.api.resource(Resource.COMPANY).list().subscribe((data: ResourceCollection<CompanyResource>) => { this.companies = data.items; });

    const filters = { company: '', orderBy: 'name', skip: 0, take: 100 };
    const company = this.cfg.get('company').value;
    if (company) {
      filters.company = company;
    }
    this.api.resource(Resource.CAMPAIGN).list(filters).subscribe((data: ResourceCollection<CampaignResource>) => { this.campaigns = data.items; });
  }

  public onCompanyChanged(): void {

    this.cfg.get('campaign').setValue(null);
    this.refreshRef();
    this.notifyChanged();
  }

  /* public onChange() {
    this.valueChanged.next(this.frm);
  } */

  public notifyChanged(ev?: Event) {

    if (ev) {
      ev.preventDefault();
    }
    if (this.frm.valid) {
      this.frm.enable();
      this.valueChanged.next(this.frm);
    }
    this.frm.markAsDirty();
  }
}
